module.exports = __webpack_public_path__ + "static/media/all.4572b5c4.png";